import { useMemo } from 'react';

import { USER_PERMISSIONS } from 'constants/userPermissions';
import { useGetCurrentUserQuery } from 'store/entities/users/api';

export const useCurrentUserInfo = (organisationId) => {
  const queryResult = useGetCurrentUserQuery();
  const { data } = queryResult;

  const getIsOrgAdmin = (orgId) =>
    data?.user_permissions?.find(({ organisation }) => organisation === orgId)?.is_organisation_admin ?? null;

  const userPermissions = useMemo(() => {
    if (!data) {
      return null;
    }

    if (data.is_superadmin) {
      return USER_PERMISSIONS.SUPER_ADMIN;
    }

    return getIsOrgAdmin(organisationId) ? USER_PERMISSIONS.ORGANISATION_ADMIN : USER_PERMISSIONS.USER;
  }, [data, getIsOrgAdmin, organisationId]);

  return {
    ...queryResult,
    userPermissions,
    userId: data?.id ?? null,
    userOrganisations: data?.user_permissions ?? [],
    getIsOrgAdmin,
    isAdminPermissions: !!userPermissions && userPermissions !== USER_PERMISSIONS.USER,
    isSuperAdminPermissions: !!userPermissions && userPermissions === USER_PERMISSIONS.SUPER_ADMIN,
    isUserPermissions: !!userPermissions && userPermissions === USER_PERMISSIONS.USER,
  };
};
